
class LayoutCache {
  constructor() {
    this.localStorageKey = 'layoutCache';
    this.store = new Map();
    this.EXPIRY_MS = 5 * 60 * 1000; 

    const data = localStorage.getItem(this.localStorageKey);
    if (data) {
      try {
        const obj = JSON.parse(data);
        Object.entries(obj).forEach(([k, v]) => {
          if (v && typeof v === 'object' && 'value' in v && 'timestamp' in v) {
            this.store.set(k, v);
          }
        });
      } catch (e) {
        localStorage.removeItem(this.localStorageKey);
      }
    }
  }

  set(key, value) {
    const item = {
      value,
      timestamp: Date.now()
    };
    this.store.set(key, item);
    this._syncToLocalStorage();
  }

  get(key) {
    const item = this.store.get(key);
    if (!item) return undefined;
    if (Date.now() - item.timestamp > this.EXPIRY_MS) {
      this.store.delete(key);
      this._syncToLocalStorage();
      return undefined;
    }
    return item.value;
  }

  has(key) {
    const item = this.store.get(key);
    if (!item) return false;
    if (Date.now() - item.timestamp > this.EXPIRY_MS) {
      this.store.delete(key);
      this._syncToLocalStorage();
      return false;
    }
    return true;
  }

  remove(key) {
    this.store.delete(key);
    this._syncToLocalStorage();
  }

  clear() {
    this.store.clear();
    localStorage.removeItem(this.localStorageKey);
  }

  _syncToLocalStorage() {
    const obj = {};
    for (let [k, v] of this.store.entries()) {
      obj[k] = v;
    }
    localStorage.setItem(this.localStorageKey, JSON.stringify(obj));
  }
}

const cacheInstance = new LayoutCache();

export default cacheInstance;
